import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

const getUpgradeState = (state: RootState) => state.upgradeSubscription;

const isUpgradeAvaliable = createSelector(getUpgradeState, (state) => {
    if (state.upgradePlan.isLoaded) {
        return state.upgradePlan.data?.result === 'success';
    }

    return false;
});

export const UpgradeSubscriptionSelectors = {
    getUpgradeState,
    isUpgradeAvaliable,
};
